export default __webpack_public_path__ + "static/media/static-banner.a42dbe1e.jpeg";